import React from 'react';
import { Navigate } from 'react-router-dom';
import { SESSION_STORAGE_IS_LOGGED_IN } from '../utils/constants';

const ProtectedRoute = ({ children }) => {
  const currentUser = sessionStorage.getItem(SESSION_STORAGE_IS_LOGGED_IN);
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
